export const url = '/users';
export const Provider = 'Users';
export const TABLE_NAME = 'users';
